import { EUserType, type TUser } from 'shared/types/user';

export const isNotSearcher = (user: TUser): boolean => {
  return user.isAuthenticated && user.lkType !== EUserType.Undefined;
};
